/* eslint no-param-reassign: "off" */
import enums from '@/utils/enum'

// Constructs a basic notification we want to send to the user
function notificationConstructor(note) {
  return {
    type: enums.notification.types.ERROR,
    msg: 'This is a standard text string, and should not be sent',
    sender: null,
    severity: enums.notification.severity.CRITICAL,
    ...note,
  }
}

// This store takes care of receiving and sending notifications to components subscribed to the list
// This is primarily used so that components can make other components aware of issues like network failures
// or run time errors
const notificationStore = {
  strict: import.meta.env.VITE_APP_ENV !== 'production',
  state: {
    notifications: [],
    bus: [],
    nouce: 0,
  },
  getters: {
    notification: (state) => state.notification,
  },
  mutations: {
    sendNotification(state, note) {
      // We create and add the notification to the current list
      state.notifications.push(notificationConstructor(note))

      state.bus.forEach((listener) => {
        // Send out the notification to all our listeners
        if (listener.hasOwnProperty('notificationHandler')) {
          listener.notificationHandler(note)
        } else if (listener.hasOwnProperty('notify')) {
          listener.notify(note)
        } else if (listener.hasOwnProperty('errorHandler')) {
          listener.errorHandler(note)
        }
      })
    },
    addToBus(state, lis) {
      const found = state.bus.find((listener) => listener._uid === lis._uid)

      if (found === undefined) {
        state.bus.push(lis)
        state.nouce += 1
      }
    },
    removeFromBus(state, lis) {
      state.bus = state.bus.filter((listener) => listener._uid !== lis._uid)
    },
  },
}

export default notificationStore
